export const RESET_CURRENT_BUILDING = 'RESET_CURRENT_BUILDING'
export const RESET_CURRENT_MEASUREMENT = 'RESET_CURRENT_MEASUREMENT'
export const RESET_CURRENT_ROOM = 'RESET_CURRENT_ROOM'
export const RESET_CURRENT_TOOL = 'RESET_CURRENT_TOOL'
export const SET_CLICKED_ITEM_TYPE = 'SET_CLICKED_ITEM_TYPE'
export const SET_CURRENT_BUILDING = 'SET_CURRENT_BUILDING'
export const SET_CURRENT_COUNTY = 'SET_CURRENT_COUNTY'
export const SET_CURRENT_DATACOMPARISON = 'SET_CURRENT_DATACOMPARISON'
export const SET_CURRENT_DRAWING_TRANSPARENCY = 'SET_CURRENT_DRAWING_TRANSPARENCY'
export const SET_CURRENT_DRONEVIEW_LINK_ID = 'SET_CURRENT_DRONEVIEW_LINK_ID'
export const SET_CURRENT_LEVEL = 'SET_CURRENT_LEVEL'
export const SET_CURRENT_MEASUREMENT = 'SET_CURRENT_MEASUREMENT'
export const SET_CURRENT_OVERLAY_MODAL = 'SET_CURRENT_OVERLAY_MODAL'
export const SET_CURRENT_POI = 'SET_CURRENT_POI'
export const SET_CURRENT_ROOM = 'SET_CURRENT_ROOM'
export const SET_CURRENT_TOOL = 'SET_CURRENT_TOOL'
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW'
export const SET_DATACOMPARISON_INTERVAL = 'SET_DATACOMPARISON_INTERVAL'
export const SET_DRAW_POINT_FEATURE = 'SET_DRAW_POINT_FEATURE'
export const SET_FEATURE_ACCESS = 'SET_FEATURE_ACCESS'
export const SET_LEVELS_FOR_SELECTED_BUILDING = 'SET_LEVELS_FOR_SELECTED_BUILDING'
export const SET_MENU_EXPANDED = 'SET_MENU_EXPANDED'
export const SET_MOBILE_SCREEN = 'SET_MOBILE_SCREEN'
export const SET_NAVVIS_API_TOKEN = 'SET_NAVVIS_API_TOKEN'
export const SET_PREVIOUS_VIEW = 'SET_PREVIOUS_VIEW'
export const SET_ROOMS_FOR_SELECTED_LEVEL = 'SET_ROOMS_FOR_SELECTED_LEVEL'
export const SET_SECONDARY_VIEW_VISIBILITY = 'SET_SECONDARY_VIEW_VISIBILITY'
export const SET_STATUS_ON_SHOW_OVERLAY_MODAL = 'SET_STATUS_ON_SHOW_OVERLAY_MODAL'
export const SET_CURRENT_ZOOM = 'SET_CURRENT_ZOOM'
export const SET_COMPLEX_SOURCE = 'SET_COMPLEX_SOURCE'
export const SET_REAL_ESTATE_SOURCE = 'SET_REAL_ESTATE_SOURCE'
export const SET_BUILDING_SOURCE = 'SET_BUILDING_SOURCE'
export const SET_CURRENT_PITCH = 'SET_CURRENT_PITCH'
export const SET_REALM_ID = 'SET_REALM_ID'
export const SET_CURRENT_PANORAMA_URL = 'SET_CURRENT_PANORAMA_URL'
export const SET_SHOW_ZONE_MENU = 'SET_SHOW_ZONE_MENU'
export const SET_POI_MENU = 'SET_POI_MENU'
// Mapviewer
export const RESET_CURRENT_COMPLEX_LAYER = 'RESET_CURRENT_COMPLEX_LAYER'
export const SET_CURRENT_COMPLEX_LAYER = 'SET_CURRENT_COMPLEX_LAYER'
export const SET_CURRENT_MAP_DRAWING_TRANSPARENCY = 'SET_CURRENT_MAP_DRAWING_TRANSPARENCY'
export const SET_CURRENT_MAP_VECTOR_TILE_ID = 'SET_CURRENT_MAP_VECTOR_TILE_ID'
export const SET_CURRENT_PREVIEW_FILE = 'SET_CURRENT_PREVIEW_FILE'
export const SET_CURRENT_REAL_ESTATE = 'SET_CURRENT_REAL_ESTATE'
export const SET_CURRENT_REGION_LAYER = 'SET_CURRENT_REGION_LAYER'
export const SET_FILTERED_MAP_LAYERS = 'SET_FILTERED_MAP_LAYERS'
export const SET_FILTERED_MAP_POI_LAYERS = 'SET_FILTERED_MAP_POI_LAYERS'
export const SET_IS_SATELLITE_ACTIVE = 'SET_IS_SATELLITE_ACTIVE'
export const SET_ZONE_DATA_FOR_REAL_ESTATE = 'SET_ZONE_DATA_FOR_REAL_ESTATE'
export const SET_SELECTED_POI_PRODUCT = 'SET_SELECTED_POI_PRODUCT'
export const SET_OUTDOOR_POI_DATA_FOR_REAL_ESTATE = 'SET_OUTDOOR_POI_DATA_FOR_REAL_ESTATE'
export const SET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE = 'SET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE'
export const SET_ZONE_CATEGORIES_FOR_REAL_ESTATE = 'SET_ZONE_CATEGORIES_FOR_REAL_ESTATE'
export const SET_MAP_IS_LOADED = 'SET_MAP_IS_LOADED'
export const SET_HOVERED_COMPLEX_ID = 'SET_HOVERED_COMPLEX_ID'
export const ADD_MAP_LAYER = 'ADD_MAP_LAYER'
export const REMOVE_MAP_LAYER = 'REMOVE_MAP_LAYER'
export const SET_MAP_VECTOR_TILE_STATE = 'SET_MAP_VECTOR_TILE_STATE'
export const SET_POI_CATEGORIES_FOR_SELECTED_BUILDING = 'SET_POI_CATEGORIES_FOR_SELECTED_BUILDING'
export const SET_POI_CATEGORIES_FOR_SELECTED_REAL_ESTATE =
  'SET_POI_CATEGORIES_FOR_SELECTED_REAL_ESTATE'

// Indoorviewer
export const CHANGE_PRIMARY_INSTANCE = 'CHANGE_PRIMARY_INSTANCE'
export const CHANGE_SECONDARY_INSTANCE = 'CHANGE_SECONDARY_INSTANCE'
export const RESET_ROUTE = 'RESET_ROUTE'
export const SET_CURRENT_LEVEL_IV_FRAME1 = 'SET_CURRENT_LEVEL_IV_FRAME1'
export const SET_CURRENT_LEVEL_IV_FRAME2 = 'SET_CURRENT_LEVEL_IV_FRAME2'
export const SET_FILTERED_PLANVIEW_LAYERS = 'SET_FILTERED_PLANVIEW_LAYERS'
export const SET_IV_LEVELS_FOR_FRAME = 'SET_IV_LEVELS_FOR_FRAME'
export const SET_NAVVIS_INSTANCE_URL = 'SET_NAVVIS_INSTANCE_URL'
export const SET_POIS_FOR_SELECTED_BUILDING_IVION = 'SET_POIS_FOR_SELECTED_BUILDING_IVION'
export const SET_POIS_FOR_SELECTED_REAL_ESTATE_IVION = 'SET_POIS_FOR_SELECTED_REAL_ESTATE_IVION'
export const SET_ROUTE = 'SET_ROUTE'
export const SET_SPLIT_INDOORVIEWER = 'SET_SPLIT_INDOORVIEWER'
export const SET_IVION_LINKS = 'SET_IVION_LINKS'
export const SET_PRIMARY_INSTANCE_POSITION = 'SET_PRIMARY_INSTANCE_POSITION'
export const SET_PRIMARY_INSTANCE_ORIENTATION = 'SET_PRIMARY_INSTANCE_ORIENTATION'

// Planview
export const IS_LOADING_MODEL = 'IS_LOADING_MODEL'
export const SET_CURRENT_HEATMAP_INTENSITY = 'SET_CURRENT_HEATMAP_INTENSITY'
export const SET_HEATMAP_DATE_ARRAY = 'SET_HEATMAP_DATE_ARRAY'
export const SET_HOVERED_ROOM_AND_SENSOR_VALUE = 'SET_HOVERED_ROOM_AND_SENSOR_VALUE'
export const SET_IS_SENSORDATA_SHOWING = 'SET_IS_SENSORDATA_SHOWING'
export const SET_CURRENT_MODEL = 'SET_CURRENT_MODEL'
export const SET_POIS_FOR_SELECTED_LEVEL = 'SET_POIS_FOR_SELECTED_LEVEL'
export const SET_POI_CATEGORIES_FOR_SELECTED_LEVEL = 'SET_POI_CATEGORIES_FOR_SELECTED_LEVEL'
export const SET_SELECTED_HEATMAP_DATE = 'SET_SELECTED_HEATMAP_DATE'
export const SET_SENSORDATA_TYPE = 'SET_SENSORDATA_TYPE'
export const SET_INDOOR_ZONE_DATA_FOR_LEVEL = 'SET_INDOOR_ZONE_DATA_FOR_LEVEL'
export const SET_ZONE_CATEGORIES_FOR_SELECTED_LEVEL = 'SET_ZONE_CATEGORIES_FOR_SELECTED_LEVEL'

// Dashboardview
export const SET_SELECTED_BUILDINGS = 'SET_SELECTED_BUILDINGS'
export const SET_SELECTED_COMPLEX = 'SET_SELECTED_COMPLEX'
export const SET_SELECTED_ITEM_TYPE = 'SET_SELECTED_ITEM_TYPE'
export const SET_SELECTED_LEVEL_DASHBOARD = 'SET_SELECTED_LEVEL_DASHBOARD'
export const SET_SELECTED_REAL_ESTATE = 'SET_SELECTED_REAL_ESTATE'
export const SET_SELECTED_ROOM_TYPES = 'SET_SELECTED_ROOM_TYPES'
export const SET_TIME_SETTING = 'SET_TIME_SETTING'
export const SET_SELECTED_DATE_INTERVAL = 'SET_SELECTED_DATE_INTERVAL'
export const SET_SELECTED_WORK_TIME = 'SET_SELECTED_WORK_TIME'
export const SET_ONLY_BOOKABLE = 'SET_ONLY_BOOKABLE'
export const SET_IS_FILTER_BUTTON_DISABLED = 'SET_IS_FILTER_BUTTON_DISABLED'
export const SET_ROOM_SIZE = 'SET_ROOM_SIZE'
export const SET_FORM = 'SET_FORM'
export const SET_QUICK_SELECT = 'SET_QUICK_SELECT'
